/**
 * 地图轨迹线点击：识别实时绘制线 / 历史轨迹线
 */

import { getRealtimeTrackLineId } from './trackDrawingOnMap';

export function parseTrackLayerClick(layerId) {
  if (!layerId || typeof layerId !== 'string') return null;
  // 透明命中层：real-time-track-{name}-hit
  if (layerId.startsWith('real-time-track-')) {
    const raw = layerId.endsWith('-hit') ? layerId.slice(0, -4) : layerId;
    return { kind: 'realtime', memberName: raw.slice('real-time-track-'.length), layerId };
  }
  if (layerId.startsWith('track-') && !layerId.startsWith('track_')) {
    const raw = layerId.endsWith('-hit') ? layerId.slice(0, -4) : layerId;
    return { kind: 'history', memberName: raw.slice('track-'.length), layerId };
  }
  return null;
}

/**
 * 在地图上绑定轨迹点击（返回卸载函数）
 */
export function bindMapTrackLineClicks(map, onTrackClick) {
  if (!map || typeof onTrackClick !== 'function') return () => {};

  const handleClick = (e) => {
    const features = map.queryRenderedFeatures(e.point) || [];
    for (const feature of features) {
      const parsed = parseTrackLayerClick(feature.layer?.id);
      if (parsed) {
        onTrackClick({
          ...parsed,
          lngLat: e.lngLat,
          point: e.point
        });
        return;
      }
    }
  };

  const handleMove = (e) => {
    const features = map.queryRenderedFeatures(e.point) || [];
    const overTrack = features.some((f) => parseTrackLayerClick(f.layer?.id));
    map.getCanvas().style.cursor = overTrack ? 'pointer' : '';
  };

  map.on('click', handleClick);
  map.on('mousemove', handleMove);

  return () => {
    try {
      map.off('click', handleClick);
      map.off('mousemove', handleMove);
      map.getCanvas().style.cursor = '';
    } catch (_) {
      /* ignore */
    }
  };
}

export function listRealtimeTrackLayerIds(memberNames = []) {
  return memberNames.map((name) => getRealtimeTrackLineId(name));
}
